// extracted by mini-css-extract-plugin
export default {"tree-view":"TreeViewDocuments_tree-view__7Aanb"};